<template>
  <div class="loading" style="height:100%;width: 100%;">
    <v-container class="loading" style="height:100%;" fluid>
      <v-row style="height:100%;">
        <v-col cols="12">
          <v-row align="center" justify="center" style="height:100%;">
            <p v-if="text" class="initialLoadingText">{{text}}</p>
            <v-progress-circular :size="30" color="primary" indeterminate></v-progress-circular>
          </v-row>
        </v-col>
      </v-row>
    </v-container>
  </div>
</template>

<script>
export default {
  props: {
    text: {
      type: String,
      default: "",
    }
  }
};
</script>
